import { ticker } from '../../../mocks/entertainment';

const quick = [
  { key: 'weekly', label: '本周热榜', icon: 'ri-fire-fill', tint: 'primary' },
  { key: 'annual', label: '年度大瓜', icon: 'ri-history-fill', tint: 'accent' },
  { key: 'moments', label: '名场面', icon: 'ri-emotion-laugh-fill', tint: 'secondary' },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[86vh] flex-col overflow-hidden bg-primary-950">
      {/* 背景图 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20entertainment%20editorial%20backdrop%20dark%20crimson%20velvet%20stage%20curtain%20with%20warm%20golden%20spotlight%20beams%20and%20soft%20red%20bokeh%20lights%20floating%20in%20air%20glossy%20film%20clapperboard%20and%20stacked%20magazine%20silhouettes%20softly%20blurred%20in%20foreground%20rich%20warm%20amber%20and%20deep%20vermillion%20cinematic%20color%20grade%20moody%20dramatic%20dense%20atmosphere%20elegant%20media%20aesthetic%20high%20contrast%20deep%20depth%20no%20people%20no%20text&width=1600&height=900&seq=hero-bg-ent&orientation=landscape"
          alt="暗红丝绒舞台与金色灯光的编辑部背景，营造吃瓜现场氛围"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60" />
      </div>

      {/* 内容 */}
      <div className="relative z-10 flex w-full flex-1 items-center">
        <div className="mx-auto w-full max-w-[1240px] px-4 py-24 text-center md:px-6 md:py-28">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-950/20 px-4 py-1.5 text-xs font-medium tracking-wide text-background-100 backdrop-blur">
            <i className="ri-radio-2-fill text-accent-400" aria-hidden="true"></i>
            本周已更新 · 娱乐精华盘点
          </span>

          <h1 className="mx-auto mt-7 max-w-4xl text-3xl font-black leading-[1.2] text-background-50 sm:text-4xl md:text-5xl">
            娱乐圈的高光与争议，
            <br className="hidden sm:block" />
            一篇给你<span className="text-accent-400">盘明白</span>
          </h1>

          <p className="mx-auto mt-6 max-w-2xl text-base text-background-100/90 md:text-lg">
            每周热门事件汇总、年度大瓜回顾、明星名场面合集。不追进度、不看直播，
            瓜友观察站帮你把一整周的瓜浓缩成一篇精华，收藏这一篇就够了。
          </p>

          <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <a
              href="#weekly"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400 sm:w-auto"
            >
              <i className="ri-fire-fill mr-2" aria-hidden="true"></i>
              看本周热榜
            </a>
            <a
              href="#annual"
              className="inline-flex w-full items-center justify-center whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/5 px-6 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/15 sm:w-auto"
            >
              翻年度大瓜
              <i className="ri-arrow-right-line ml-2" aria-hidden="true"></i>
            </a>
          </div>

          {/* 快捷栏目 */}
          <div className="mx-auto mt-10 flex max-w-3xl flex-col items-stretch justify-center gap-3 sm:flex-row">
            {quick.map((q) => (
              <a
                key={q.key}
                href={`#${q.key}`}
                className="flex items-center justify-center gap-2 rounded-lg border border-background-50/15 bg-background-950/20 px-5 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:border-background-50/30 hover:bg-background-950/35"
              >
                <i className={`${q.icon} text-accent-400`} aria-hidden="true"></i>
                {q.label}
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* 头条跑马灯 */}
      <div className="relative z-10 border-t border-background-50/15 bg-background-950/45 backdrop-blur">
        <div className="flex items-stretch">
          <div className="flex shrink-0 items-center gap-2 bg-accent-500 px-4 py-2.5 text-background-950 md:px-6">
            <i className="ri-chat-3-fill text-sm" aria-hidden="true"></i>
            <span className="text-sm font-bold whitespace-nowrap">吃瓜速递</span>
          </div>
          <div className="relative flex-1 overflow-hidden py-2.5">
            <div className="animate-marquee flex w-max items-center gap-8 pl-6">
              {[...ticker, ...ticker].map((t, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-sm text-background-100/90">
                  <i className="ri-arrow-right-s-fill text-accent-400" aria-hidden="true"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}